



























































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import FileUpload from "@/components/common/Inputs/FileUpload.vue";
import FileDownload from "@/components/common/fileDownload/fileDownload.vue";

@Component({
  components: {
    FileUpload,
    FileDownload,
  },
})
export default class DocumentListComponent extends Vue {
  @Prop({ default: [] }) tags!: Array<any>;
  @Prop() model!: any;
  @Prop() subKey!: string;
  @Prop() transactionId!: number;
  @Prop({ default: [] }) languages!: Array<any>;
  @Prop() tagId!: number;

  beforeMount() {
    if(!this.model[this.subKey])
        this.model[this.subKey] = [];
  }

  get files() {
    return this.model[this.subKey];
  }

  addNewRow() {
    this.files.push({});
    this.$forceUpdate();
  }

  onUpload(e, item) {
    var self = this;

    this.$services.document
      .uploadDocument(
        e,
        {
          options: {
            docTag: item.tagId || this.tagId,
            menu: null,
          },
        },
        self.transactionId,
        item.language || self.$vuetify.lang.current
      )
      .then((data) => {
        //let file = self.files.find((x) => x.tagId == item.tagId);
        item.name = data.name;
        item.uploadedFileName = data.uploadedFileName;
        item.documentId = data.documentId;

        self.$forceUpdate();
        self.$emit("input", true);
        self.$emit("save");
      });
  }

  onRemoveFile(index, doc) {
    if (doc.documentId) {
      this.$services.document.removeDocument(doc).then((data) => {
        this.files.splice(index, 1);
        this.$forceUpdate();
        this.$emit("input", true);
        this.$emit("save");
      });
    }
  }
}
